import { Component, OnInit } from '@angular/core';
import { Router, } from '@angular/router';
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { ViewportScroller } from '@angular/common';
import { FetchDataService } from '../core/services/fetch-data.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  // baseUrl = environment.mainUrl;
  user;
  uid: number;
  email = '';
message = '';
submitted = false;
showToast = false;
toastMessage = '';
toastType: 'success' | 'error' = 'success';
toastImg = '';

  constructor(private router: Router, private http: HttpClient, private viewportScroller: ViewportScroller,private fetchData: FetchDataService) { }
  extra = true;
  ngOnInit(): void {


    this.user = JSON.parse(localStorage.getItem('clpUser'));
    if (localStorage.getItem("clpUser") != null) {
      this.extra = false;

    }
  }
customOptions: OwlOptions = {
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,      // image kitni der rahe
  autoplaySpeed: 1000,        // transition speed (IMPORTANT)
  smartSpeed: 1000,           // smooth sliding
  dots: true,
  nav: false,
  animateOut: 'fadeOut',      // smooth fade effect
  animateIn: 'fadeIn',
  responsive: {
    0: { items: 1 },
    600: { items: 1 },
    1000: { items: 1 }
  }
};

carouselImages: string[] = [
'assets/newImages/home1.jpg',
'assets/newImages/home2.jpg',
'assets/newImages/home3.jpg'
];

  logout() {

    // this.router.navigate(['/account/login']);
    localStorage.clear();
  //     localStorage.removeItem("clpUser");
  // localStorage.removeItem("token");
  // localStorage.removeItem("gdpr_seen_banner");

     this.router.navigate(['/account/login']).then(() => {
    window.location.reload();
  });
  }
  dashboard() {
    this.user = JSON.parse(localStorage.getItem('clpUser')).type
    if (this.user == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }

  }
  gotoScroll(itemId:string){
    this.viewportScroller.scrollToAnchor(itemId);
  }


showToastMessage(type: 'success' | 'error', message: string) {
  this.toastType = type;
  this.toastMessage = message;
  this.toastImg =
    type === 'success'
      ? '/assets/newImages/toast icon success.png'
      : 'assets/images/error.png';

  this.showToast = true;

  setTimeout(() => {
    this.showToast = false;
  }, 3000);
}
closeToast() {
  this.showToast = false;
}
onSubscribe(form: any) {
  this.submitted = true;

  if (form.invalid) {
    return;
  }

  this.fetchData.saveNewsletter(this.email).subscribe({
    next: () => {
      this.showToastMessage('success', 'You are subscribed');
      this.submitted = false;
      form.resetForm();
    },
    error: () => {
      this.showToastMessage('error', 'Something went wrong');
    }
  });
}

}
